import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/next/src/components/pages/Error404/Error404.tsx");
